<template>
  <a-spin size="large" class="spin" tip="载入中..." :spinning="spinning">
    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    <div class="article-form">
      <div class="main-form">
        <a-row style="margin-bottom: 0">
          <a-tabs defaultActiveKey="1">
            <a-tab-pane :tab="status" key="1">
              <a-row>
                <a-input-group compact>
                  <a-select
                    :defaultValue="article.class"
                    v-model="article.class"
                    size="large"
                    style="width: 80px"
                  >
                    <a-select-option
                      :value="item.key"
                      v-for="(item, index) in $store.state.articleClass"
                      :key="index"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                  <a-input
                    defaultValue="mysite"
                    style="width: calc(100% - 80px)"
                    size="large"
                    v-model="article.title"
                    placeholder="文章标题"
                  >
                    <!--<a-input defaultValue="mysite" size="large" v-model="article.title" placeholder="文章标题" >-->
                    <a-icon
                      slot="addonAfter"
                      type="edit"
                      :theme="showSubTitle ? 'filled' : 'outlined'"
                      @click="showSub"
                      style="cursor: pointer"
                      @mouseenter="showSubTitleTips()"
                      @mouseleave="closeSubTitleTips()"
                    />
                  </a-input>
                </a-input-group>
              </a-row>
              <a-row v-show="showSubTitle">
                <a-input placeholder="副标题" v-model="article.subtitle" />
              </a-row>
              <a-row class="cate-set">
                <a-col>
                  <a-tree-select
                    style="width: 100%"
                    showSearch
                    :treeData="treeData"
                    :value="valueTree"
                    @change="onChange"
                    treeCheckable
                    searchPlaceholder="请选择栏目"
                    allowClear
                    treeDefaultExpandAll
                    :filterTreeNode="filterTreeNode"
                    :dropdownStyle="{ maxHeight: '600px' }"
                    :dropdownClassName="'select-color'"
                  />
                </a-col>
                <!--<a-col :span="8" style="padding-left: 10px">-->
                <!--<span class="intro">专题：</span>-->
                <!--<a-select-->
                <!--placeholder="请选择关联专题"-->
                <!--:defaultValue="[]"-->
                <!--mode="multiple"-->
                <!--:maxTagCount="1"-->
                <!--@change="tagChange"-->
                <!--style="width:100%;"-->
                <!--v-model="specId"-->
                <!--&gt;-->
                <!--<a-select-option v-for="(i,index) in specList" :key="i.catid" :value="i.catid" style="width: 60%">-->
                <!--{{ i.catname }}-->
                <!--</a-select-option>-->
                <!--</a-select>-->
                <!--</a-col>-->
              </a-row>
              <a-row>
                <editor
                  :detail="article.content"
                  @getEditorDetail="getEditorDetail"
                  @showModal="showModal(-1)"
                  @showVideo="loadCloudVideo"
                  @showAudio="showAudioModal"
                  ref="editor"
                ></editor>
              </a-row>
              <a-row></a-row>
            </a-tab-pane>
          </a-tabs>
        </a-row>
      </div>
      <a-card :bordered="true" class="attr-form" hoverable>
        <div style="padding: 10px">
          <a-row justify="end" class="select-type">
            <a-col :span="6" class="title-pic">
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>推荐</span>
                </template>
                <a-button
                  :type="article.recommend == '1' ? 'primary' : 'dashed'"
                  shape="circle"
                  :icon="recommend.ico"
                  @click="checkRec()"
                />
              </a-tooltip>
            </a-col>
            <a-col :span="18">
              <!--<a-button-->
              <!--:type="article.type.indexOf(index+1) > -1 ? 'primary' : 'dashed'"-->
              <!--shape="circle"-->
              <!--:icon="i.ico"-->
              <!--v-for="(i,index) in articleTypes"-->
              <!--:key="index"-->
              <!--@click="checkTypes(index+1)"-->
              <!--/>-->

              <a-tooltip
                placement="topLeft"
                v-for="(i, index) in articleTypes"
                :key="index"
              >
                <template slot="title">
                  <span>{{ i.label }}</span>
                </template>
                <a-button
                  :type="
                    article.type.indexOf(index + 1) > -1 ? 'primary' : 'dashed'
                  "
                  shape="circle"
                  :icon="i.ico"
                  :key="index"
                  @click="checkTypes(index + 1)"
                />
              </a-tooltip>
            </a-col>
          </a-row>
          <a-row style="overflow: hidden" :style="'height: ' + height + 'px;'">
            <a-upload-dragger
              name="file"
              accept="image/*"
              :headers="headers"
              :beforeUpload="beforeUpload"
              style="display: none"
            >
              <a-icon type="inbox" id="imgupload" />
            </a-upload-dragger>
            <div
              class="upload-div"
              :style="'height:' + height + 'px'"
              @click="showModal(0)"
              v-if="imgLists[0] == ''"
            >
              <div style="padding: 0">
                <p class="ant-upload-drag-icon" v-if="height == 180">
                  <a-icon type="inbox" id="imgupload" />
                </p>
                <p
                  class="ant-upload-text"
                  :class="{ textMargin: height == 100 }"
                >
                  点击选择封面图
                </p>
              </div>
            </div>
            <div
              v-else
              style="
                color: #fff;
                border: dashed 1px #d9d9d9;
                border-radius: 3px;
                padding: 2px;
              "
            >
              <img
                :src="imgLists[0]"
                style="width: 100%; height: 100%; border-radius: 3px"
                @click="showModal(0)"
              />
              <a-icon class="img-delete" type="close" @click="removeImg(0)" />
            </div>
          </a-row>
          <a-row class="img-lists" v-if="article.headpictype == '2'">
            <div v-for="i in 2" @click="showModal(i)" :key="i">
              <img
                :src="imgLists[i]"
                v-show="imgLists[i] != '' && imgLists[i].length > 10"
                style="width: 100%; height: 100%"
              />
            </div>
          </a-row>
          <a-row>
            <a-radio-group
              @change="changeHeadpicType"
              v-model="article.headpictype"
            >
              <a-radio-button value="1">默认</a-radio-button>
              <a-radio-button value="2">三图</a-radio-button>
              <a-radio-button value="3" style="padding: 0 13px"
                >4:3大图</a-radio-button
              >
              <a-radio-button value="4" style="padding: 0 13px"
                >3:1宽图</a-radio-button
              >
            </a-radio-group>
          </a-row>
          <a-row>
            <a-textarea
              placeholder="请输入文章摘要，勿超过100字"
              :autoSize="{ minRows: 2, maxRows: 4 }"
              v-model="article.abstract"
            />
          </a-row>
          <!--<a-row>-->
          <!--<a-select-->
          <!--mode="tags"-->
          <!--placeholder="请设置关键词"-->
          <!--@change="tagChange"-->
          <!--:defaultValue="[]"-->
          <!--style="width: 100%"-->
          <!--&gt;-->
          <!--<a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">-->
          <!--{{(i + 9).toString(36) + i}}-->
          <!--</a-select-option>-->
          <!--</a-select>-->
          <!--</a-row>-->
          <a-row>
            <a-input-group>
              <a-col :span="8">
                <a-input placeholder="文章来源" v-model="article.comefrom" />
              </a-col>
              <a-col :span="16">
                <a-input
                  placeholder="记者，多个请用逗号隔开"
                  v-model="article.adduser"
                />
              </a-col>
            </a-input-group>
          </a-row>
          <!--<a-row>-->
          <!--<a-input placeholder="文章来源" v-model="article.comefrom" />-->
          <!--</a-row>-->
          <a-row>
            <a-input-group compact>
              <!--                        <a-tooltip placement="topLeft">-->
              <!--                            <template slot="title">-->
              <!--                                <span>插入文章</span>-->
              <!--                            </template>-->
              <!--                            <a-button type="primary" style="padding:0 10px;" @click="insertVideo">-->
              <!--                                <a-icon type="left" />-->
              <!--                            </a-button>-->
              <!--                        </a-tooltip>-->

              <a-tooltip placement="topLeft">
                <template slot="title" v-if="article.attach != ''">
                  <span>{{ article.attach }}</span>
                </template>
                <a-input
                  placeholder="外部视频地址"
                  v-model="article.attach"
                ></a-input>
              </a-tooltip>
              <!--                        <a-button type="primary" style="position: absolute;right: 0;" @click="loadCloudVideo">云视频</a-button>-->
              <!--<a-input-search placeholder="视频地址" @search="loadCloudVideo" v-model="article.attach" style="padding-right: 40px;width: 240px" v-else >-->
              <!--<a-button slot="enterButton" type="primary">云视频</a-button>-->
              <!--</a-input-search>-->

              <!--<a-input style="width: 50%" defaultValue="input content" />-->
              <!--<a-input-search placeholder="视频地址" @search="loadCloudVideo" v-model="article.attach" style="width: 240px">-->
              <!--<a-button slot="enterButton" type="primary" style="padding:0 10px;">云视频</a-button>-->
              <!--</a-input-search>-->
            </a-input-group>
            <!--<a-tooltip placement="topLeft" v-if="article.attach!=''" >-->
            <!--<template slot="title">-->
            <!--<span>{{ article.attach }}</span>-->
            <!--</template>-->
            <!--<a-input-search placeholder="视频地址" @search="loadCloudVideo" v-model="article.attach" style="padding-right: 40px" >-->
            <!--<a-button slot="enterButton" type="primary">云视频</a-button>-->
            <!--</a-input-search>-->
            <!--</a-tooltip>-->
            <!--<a-input-search placeholder="视频地址" @search="loadCloudVideo" v-model="article.attach" style="padding-right: 40px" v-else >-->
            <!--<a-button slot="enterButton" type="primary">云视频</a-button>-->
            <!--</a-input-search>-->
          </a-row>
          <!--<a-row>-->
          <!--<a-select-->
          <!--mode="tags"-->
          <!--placeholder="作者"-->
          <!--@change="tagChange"-->
          <!--:defaultValue="[]"-->
          <!--style="width: 100%"-->
          <!--&gt;-->
          <!--<a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">-->
          <!--{{(i + 9).toString(36) + i}}-->
          <!--</a-select-option>-->
          <!--</a-select>-->
          <!--</a-row>-->
          <a-row>
            <a-date-picker
              format="将于 YYYY-MM-DD HH:mm:ss 上线"
              :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
              style="width: 100%"
              placeholder="设置上线时间"
              v-model="pubtime"
            />
          </a-row>
          <a-row>
            <a-input
              :addonBefore="before"
              placeholder="跳转链接"
              v-model="article.linkurl"
            />
          </a-row>
          <!--<a-row>-->
          <!--<a-date-picker-->
          <!--format="将于 YYYY-MM-DD HH:mm:ss 下线"-->
          <!--:showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"-->
          <!--style="width: 100%"-->
          <!--placeholder="设置下线时间"-->
          <!--/>-->
          <!--</a-row>-->
          <a-row>
            <a-input-group>
              <a-col :span="12">
                <a-input-number
                  placeholder="初始阅读量"
                  style="width: 100%"
                  v-model="article.readnums"
                />
              </a-col>
              <a-col :span="12">
                <a-input-number
                  placeholder="初始点赞量"
                  style="width: 100%"
                  v-model="article.goodnums"
                />
              </a-col>
            </a-input-group>
          </a-row>
          <a-row>
            <!--<a-radio-group v-model="article.share" buttonStyle="solid">-->
            <!--<a-radio-button value="0">不共享</a-radio-button>-->
            <!--<a-radio-button value="1">共享</a-radio-button>-->
            <!--</a-radio-group>-->
            <div>
              <a-input-group compact>
                <!--                            <a-button type="primary">是否共享</a-button>-->
                <a-select v-model="article.share" style="width: 100px">
                  <a-select-option value="0">不共享</a-select-option>
                  <a-select-option value="1">共享</a-select-option>
                </a-select>
                <div
                  style="
                    padding-left: 15px;
                    height: 30px;
                    line-height: 30px;
                    width: 30px;
                  "
                >
                  <a-popconfirm
                    placement="topRight"
                    okText="知道了"
                    cancelText="取消"
                  >
                    <template slot="title">
                      <p>
                        选择"共享"将在审核发布后授权允许融媒体其他站点转载该文章。
                      </p>
                    </template>
                    <a-icon type="question-circle" />
                  </a-popconfirm>
                </div>
                <a-form-item
                  label="是否原创："
                  :label-col="{ span: 20 }"
                  :wrapper-col="{ span: 4 }"
                  style="position: absolute; right: 25px"
                >
                  <a-switch
                    checkedChildren="是"
                    unCheckedChildren="否"
                    @change="onChangeOriginal"
                    defaultChecked
                  />
                </a-form-item>
              </a-input-group>
            </div>
          </a-row>
        </div>

        <!--<div>-->
        <!--<span>标题图片</span>-->
        <!--<div>-->
        <!--<a-avatar icon="user" />-->
        <!--<a-avatar icon="user" />-->
        <!--<a-avatar icon="user" />-->
        <!--<a-avatar icon="user" />-->
        <!--</div>-->
        <!--</div>-->
      </a-card>
      <footer-tool-bar>
        <a-button
          type="danger"
          v-if="
            setSiteInfo.site_id === '2' ||
              setSiteInfo.site_id === '18' ||
              setSiteInfo.site_id === '19' ||
              setSiteInfo.site_id === '16' ||
              setSiteInfo.site_id === '15'
          "
          @click="cmsword()"
          >错字识别</a-button
        >
        <a-button @click="handleSubmit(0)" :loading="loading"
          >保存草稿</a-button
        >
        <a-button type="primary" @click="setSubmit()" :loading="loading"
          >提交审核</a-button
        >
      </footer-tool-bar>
      <a-drawer
        title="云视频"
        placement="right"
        :closable="false"
        @close="onClose"
        width="330"
        :visible="cloudVideoVisible"
      >
        <div class="video-lists-main" style="z-index: 1002">
          <div style="width: 100%; height: 40px; padding: 10px 0 0 20px">
            <a-input-search
              placeholder="请输入视频标题搜索"
              v-model="videoParam.keyword"
              style="width: 200px; margin-right: 10px"
              @search="onVideoSearch"
              @keyup.esc="resetVideo"
            />
            <a-button type="primary" @click="resetVideo()">重置</a-button>
          </div>
          <div
            v-for="(item, index) in cloudVideoLists"
            :key="index"
            class="video-lists"
            @click="selectVideo(item)"
          >
            <img :src="item.CoverURL" alt width="280px" height="180px" />
            <div
              style="
                text-align: center;
                height: 28px;
                line-height: 28px;
                overflow-x: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              {{ item.Title }}
            </div>
          </div>
          <div style="padding: 5px">
            <a-button type="dashed" block size="small" @click="getVideoLists()"
              >加载更多...</a-button
            >
          </div>
        </div>
      </a-drawer>

      <a-modal
        title="请选择需要插入的图片"
        v-model="visible"
        width="1140px"
        :footer="null"
        :bodyStyle="{ padding: 0 }"
      >
        <div
          style="
            width: 100%;
            height: 40px;
            padding: 10px 20px;
            position: relative;
          "
        >
          搜索：
          <a-input-search
            placeholder="请输入图片标题"
            v-model="imgParam.keyword"
            style="width: 400px; margin-right: 10px"
            @search="onImgSearch"
            @keyup.esc="resetImg"
          />
          <a-button @click="resetImg()" style="margin-right: 10px"
            >重置</a-button
          >
          <a-button type="primary" @click="uploadImg()">
            上传至云图库
            <a-icon type="cloud-upload" />
          </a-button>
          <div
            style="
              position: absolute;
              right: 20px;
              top: 5px;
              height: 40px;
              line-height: 40px;
            "
          >
            <a-button
              :type="!myChecked ? 'dashed' : 'link'"
              icon="check-square"
              @click="onChangeUser"
              >只看我的</a-button
            >
          </div>
        </div>
        <div class="picture-area">
          <div class="picture-list">
            <a-spin :spinning="picLoadingMore" size="large">
              <div class="lists">
                <ul>
                  <li
                    v-for="(item, index) in picLists"
                    :key="index"
                    class="pic-lists"
                    @click="insertImg(item.url)"
                  >
                    <div class="imgs">
                      <img :src="item.url + '/thumb_400'" alt />
                    </div>
                    <div class="title">{{ item.filename }}</div>
                  </li>
                </ul>
                <div class="more">
                  <a-button @click="loadmore" v-if="!picLoadingMore">
                    加载更多
                  </a-button>
                </div>
              </div>
            </a-spin>
          </div>
        </div>
      </a-modal>

      <a-modal
        title="请选择需要插入的音频"
        v-model="audioVisible"
        width="1140px"
        :footer="null"
        :bodyStyle="{ padding: 0 }"
      >
        <div style="width: 100%; height: 40px; padding: 10px 20px">
          搜索：
          <a-input-search
            placeholder="请输入音频名称"
            v-model="audioParam.keyword"
            style="width: 400px; margin-right: 10px"
            @search="onAudioSearch"
            @keyup.esc="resetAudio"
          />
          <a-button type="primary" @click="resetAudio()">重置</a-button>
        </div>
        <div class="picture-area">
          <div class="picture-list">
            <div class="lists">
              <ul>
                <li
                  v-for="(item, index) in audioLists"
                  :key="index"
                  class="pic-lists"
                  @click="insertAudio(item)"
                >
                  <div class="imgs">
                    <img src="../../../public/images/audio-default.jpg" alt />
                  </div>
                  <div class="title">{{ item.Title }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import editor from '../../components/Editor';
import moment from 'moment';
import FooterToolBar from '../../components/FooterToolBar';
import { TreeSelect } from 'ant-design-vue';
export default {
  name: 'Add',
  components: {
    editor,
    FooterToolBar
  },
  data() {
    return {
      setSiteInfo: new Object(), //用户信息
      valueTree: undefined,
      treeData: [],
      spinning: false,
      height: 180,
      videokeyword: '',
      imgkeyword: '',
      videoImg: '',
      cloudVideoVisible: false,
      cloudVideoLists: [],
      visible: false,
      picLists: [],
      status: '添加文章',
      imgLists: ['', '', ''],
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      catid: [],
      specId: [],
      changeIndex: 0,
      showSubTitle: true,
      subTitleTip: false,
      subTitleTipShowed: false,
      cateList: [],
      specList: [],
      recommend: { ico: 'book', check: false },
      articleTypes: [
        { ico: 'desktop', check: false, label: 'PC网站' },
        { ico: 'mobile', check: false, label: 'App' },
        { ico: 'html5', check: false, label: '移动端' }
      ],
      param: { artycleTypes: [] },
      value: 1,
      previewVisible: false,
      previewImage: '',
      fileList: [
        {
          uid: '-1',
          name: 'xxx.png',
          status: 'done',
          url:
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
        }
      ],
      article: {
        id: '',
        class: '1',
        title: '',
        subtitle: '',
        comefrom: '',
        content: '',
        abstract: '',
        headpic: '',
        linkurl: '',
        attach: '',
        type: '123',
        recommend: '0',
        pubtime: '',
        listorder: '',
        catid: '',
        original: 1,
        share: '1',
        readnums: '',
        goodnums: '',
        adduser: '',
        headpictype: '1'
      },
      pubtime: moment(),
      loading: false,
      before: 'http://',
      videoParam: {
        page: 1,
        keyword: ''
      },
      picLoadingMore: false,
      imgParam: {
        page: 0,
        keyword: ''
      },
      audioVisible: false,
      audioParam: {
        page: 0,
        keyword: ''
      },
      audioLists: [],
      position: -1,
      myChecked: false
    };
  },
  watch: {
    article: {
      handler(val, oldVal) {
        if (val.attach.indexOf('http://vod.cn3x.com.cn/video/') == -1) {
          this.videoImg = '';
        }
        let linkurl = val.linkurl;
        let pre = val.linkurl.substr(0, 8);
        if (pre.toLowerCase().indexOf('http://') > -1) {
          this.before = 'http://';
          val.linkurl = val.linkurl.substr(7);
        } else if (pre.toLowerCase().indexOf('https://') > -1) {
          this.before = 'https://';
          val.linkurl = val.linkurl.substr(8);
        }
      },
      deep: true
    }
    // catid(){
    //     let catidArr = []
    //     for (let i in this.cateList) {
    //         catidArr.push(this.cateList[i].catid)
    //     }
    //     // console.log(JSON.stringify(this.cateList))
    //     // let catidArr = []
    //     // for (let i in this.catid) {
    //     //     if (this.catid[i])
    //     // }
    //     // this.catid = this.catid
    // }
    // article (val,oldVal){
    //     console.log(val,oldVal)
    // }
    // }
  },
  created() {
    this.init();
    let id = this.$route.query.id;
    let type = this.$route.query.type;
    if (typeof id != 'undefined') {
      this.spinning = true;
      this.status = '编辑文章';
      setTimeout(() => {
        this.loadDetail(id);
      }, 300);
      setTimeout(() => {
        this.spinning = false;
      }, 2000);
    }
    this.myChecked =
      window.localStorage.getItem('myChecked') == 'true' ? true : false;
    // if (this.myChecked == 'null') {
    //   window.localStorage.setItem('myChecked',false)
    //   this.myChecked = false
    // }
    if (type === 'mass') {
      let data = JSON.parse(window.localStorage.getItem('massArticle'));
      this.article.title = data.title;
      if (this.setSiteInfo.site_id == 16) {
        this.article.content =
          data.content +
          `<div style="text-align:right">审核人：${data.finalizerName}</div>`;
      }
      this.article.comefrom = data.deptName;
      this.article.adduser = data.creatorName;
      this.pubtime = moment(data.createTime);
      this.article.abstract = data.overview;
      this.headpic = data.cover ? [data.cover] : [];
      if (data.cover) {
        // if (JSON.parse(data.cover).length > 0) {
        this.imgLists[0] = data.cover;
        //}
      }
    }
  },
  mounted() {
    this.getCateList();
    this.getPicLists();
    this.getVideoLists();
    this.getAudioLists();
  },
  methods: {
    onChangeUser(e) {
      this.myChecked = !this.myChecked;
      window.localStorage.setItem('myChecked', this.myChecked);
      this.imgParam.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    init() {
      this.setSiteInfo = JSON.parse(localStorage.getItem('siteinfo'));
    },
    onChange(value) {
      this.valueTree = value;
      this.catid = this.valueTree;
    },
    removeImg(position) {
      this.imgLists = ['', '', ''];
    },
    cateFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    uploadImg() {
      // this.$refs.imgupload.click();
      document.getElementById('imgupload').click();
    },
    insertAudio(item) {
      // console.log(item.id)
      // `<p><img src="../../public/images/audio.jpg" id="${item.id}" class="ycrmt_aideo"></p>`
      this.$refs.editor.insertContent(
        `<p><img src="/images/audio.jpg" id="${item.id}" class="ycrmt_audio" height="45" width="365"></p>`
      );
      this.audioVisible = false;
    },
    onAudioSearch() {
      this.audioParam.page = 1;
      this.audioLists = [];
      this.getAudioLists();
      // console.log('onVideoSearch')
    },
    resetAudio() {
      this.audioParam.keyword = '';
      this.audioParam.page = 1;
      this.audioLists = [];
      this.getAudioLists();
    },
    showAudioModal() {
      this.audioVisible = true;
      // console.log('audio')
    },
    getAudioLists() {
      this.$http
        .post('/api/AliyunAudio/AudioLists', this.audioParam)
        .then(res => {
          if (res.data.state == 200) {
            for (let i in res.data.data) {
              this.audioLists.push(res.data.data[i]);
            }
          }
        });
    },
    onVideoSearch() {
      this.videoParam.page = 1;
      this.cloudVideoLists = [];
      this.getVideoLists();
    },
    resetVideo() {
      this.videoParam.keyword = '';
      this.videoParam.page = 1;
      this.cloudVideoLists = [];
      this.getVideoLists();
    },
    changeHeadpicType(e) {
      if (parseInt(e.target.value) == 4) {
        this.height = 100;
        this.imgLists[0] = this.imgLists[0].replace('480_320', '600_200');
      } else {
        this.height = 180;
        this.imgLists[0] = this.imgLists[0].replace('600_200', '480_320');
      }
      this.article.headpictype = e.target.value;
    },
    imgDel(i) {
      console.log(i);
    },
    selectVideo(item) {
      this.$refs.editor.insertContent(
        `<p><img src="${item.CoverURL}" width="480" height="320" id="${item.id}" class="ycrmt_video"></p>`
      );

      this.cloudVideoVisible = false;
    },
    showSubTitleTips() {
      if (this.subTitleTipShowed == false) {
        this.subTitleTip = true;
        setTimeout(() => {
          if (this.subTitleTip == true) {
            this.$notification.open({
              message: '小贴士',
              description: '点击该按钮将展开副标题选项。'
            });
            this.subTitleTipShowed = true;
          }
        }, 1500);
      }
    },
    closeSubTitleTips() {
      this.subTitleTip = false;
    },
    getVideoLists() {
      this.$http
        .post('/api/AliyunVideo/VideoLists', this.videoParam)
        .then(res => {
          for (let i in res.data.data) {
            res.data.data[i].CoverURL = res.data.data[i].CoverURL.replace(
              /fusion-media-wf.oss-cn-hangzhou.aliyuncs.com/,
              'cdn.ycrmt.cn'
            );
            res.data.data[i].FileURL = res.data.data[i].FileURL.replace(
              /vod-media-wf.oss-cn-hangzhou.aliyuncs.com/,
              'vod.ycrmt.cn'
            );
            res.data.data[i].CoverURL;
            this.cloudVideoLists.push(res.data.data[i]);
          }
          this.videoParam.page++;
        });
    },
    onClose() {
      this.cloudVideoVisible = false;
    },
    loadCloudVideo() {
      this.cloudVideoVisible = true;
    },
    insertImg(src) {
      this.visible = false;
      if (this.position == -1) {
        if (src.slice(-3) == 'gif') {
          this.$refs.editor.insertContent(`<p><img src=${src}></p>`);
        } else {
          this.$refs.editor.insertContent(
            `<p><img src=${src + '/thumb_800'}></p>`
          );
        }
      } else {
        var suffix = '/480_320';
        if (this.position == 0) {
          if (this.article.headpictype == 4) {
            suffix = '/600_200';
          }
          this.imgLists[0] = src;
          if (src.slice(-3) != 'gif') {
            this.imgLists[0] = this.imgLists[0] + suffix;
          }
        } else {
          this.imgLists[this.position] = src + suffix;
        }
      }
    },
    insertVideo() {
      // console.log(this.videoImg)
      // console.log(this.article.attach)
      if (this.videoImg != '') {
        this.$refs.editor.insertContent(
          `<div class="video"><img src=${this.videoImg} class="thumb"><img src="/images/play-ico.png" class="play-ico"></div>`
        );
      } else {
        this.$refs.editor.insertContent(
          `<div class="video"><img src="http://cjyun.ycydt.cn/video/img/video-bj1.jpg"}></div>`
        );
      }
    },
    onChangeOriginal(checked) {
      this.article.original = checked ? 1 : 0;
    },
    onImgSearch() {
      this.imgParam.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    resetImg() {
      this.imgParam.keyword = '';
      this.imgParam.page = 1;
      this.picLists = [];
      this.getPicLists();
    },
    loadmore() {
      const imgParam = { ...this.imgParam };
      imgParam.page += 1;
      this.imgParam = imgParam;
      this.picLoadingMore = true;
      this.getPicLists();
    },
    getPicLists() {
      if (this.myChecked) {
        let userinfo = JSON.parse(localStorage.getItem('siteinfo'));
        this.imgParam.userid = userinfo.userid;
      } else {
        delete this.imgParam.userid;
      }

      this.$http.post('/api/AliyunOss/lists', this.imgParam).then(res => {
        if (res.data.state == 200) {
          for (let i in res.data.data) {
            this.picLists.push(res.data.data[i]);
          }
          this.picLoadingMore = false;
        }
      });
    },
    showModal(type) {
      this.position = parseInt(type);
      // this.picLists = []
      // this.getPicLists()
      this.visible = true;
    },
    loadDetail(id) {
      this.$http.post('/api/content/clouddetail', { id: id }).then(res => {
        this.article = res.data.data;
        this.reviewer = res.data.data.shhr;
        // this.imgLists = this.article.headpic
        for (let i in this.article.headpic) {
          if (this.article.headpic[i] != '') {
            this.imgLists[i] = this.article.headpic[i];
          }
        }
        this.valueTree = res.data.data.catid;
        // 取出所有栏目
        let catArr = res.data.data.catid;
        for (let i in catArr) {
          // 将栏目id转换成str与栏目数组比较
          let cateStr = String(catArr[i]);
          // 设置开关
          let isCate = false;
          for (let n in this.cateList) {
            if (cateStr === this.cateList[n].catid) {
              // 是栏目
              isCate = true;
            }
          }
          if (isCate) {
            this.catid.push(cateStr);
          } else {
            this.specId.push(cateStr);
          }
        }
        // 在栏目列表中遍历，如果不是栏目，则添加到专题
        if (this.article.headpictype == 4) {
          this.height = 95;
        }
        this.pubtime = moment(this.article.pubtime);
      });
    },
    changeImg(i) {
      this.changeIndex = i;
      document.getElementById('imgupload').click();
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.picLists = [];
        this.param.page = 1;
        this.getPicLists();
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    setSubmit() {
      let that = this;
      this.$confirm({
        title: '确认提交审核吗？',
        content: '一旦提交审核，您将无法修改稿件。如需修改，请保存为草稿。',
        onOk() {
          that.handleSubmit(1);
        },
        onCancel() {}
      });
    },
    handleSubmit(submit) {
      // const dataStr = JSON.stringify(this.article)
      var data = this.article;
      data.pubtime = moment(this.pubtime).format('YYYY-MM-DD HH:mm:ss');
      let catidArr = this.catid.concat(this.specId);
      data.catid = catidArr.join(',');
      if (this.valueTree) {
        data.catid = this.valueTree.join(',');
      }

      // 去除标题图中的空图片
      var headpic = [];
      for (let i in this.imgLists) {
        if (this.imgLists[i] != '') headpic.push(this.imgLists[i]);
      }
      data.headpic = JSON.stringify(headpic);
      // 判断是否保存为草稿
      let message = '草稿';
      if (submit == 1) {
        data.submit = submit;
        message = '文章';
      }
      this.loading = true;
      if (data.readnums == '') {
        data.readnums = 0;
      }
      if (data.goodnums == '') {
        data.goodnums = 0;
      }
      data.linkurl = data.linkurl;
      let dataStr = JSON.stringify(data);
      let dataObj = JSON.parse(dataStr);
      if (dataObj.linkurl != '') {
        dataObj.linkurl = this.before + dataObj.linkurl;
      }
      if (this.setSiteInfo.site_id === '2') {
        dataObj.shhr = this.reviewer;
      }
      dataObj.content = this.utf16toEntities(dataObj.content);
      this.$http.post('/api/content/cloudupdate', dataObj).then(res => {
        if (res.data.state == 200) {
          if (data.id == '') {
            this.$message.success(message + '保存成功');
          } else {
            this.$message.success(message + '编辑成功');
          }
          // window.localStorage.set({ keep: true });
          this.$router.push('./Lists');
        } else {
          this.$message.warning(
            res.data.message + '，文章标题、栏目、内容均不能为空'
          );
          this.loading = false;
        }
      });
    },
    moment,
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { limit: 9999 })
        .then(res => {
          for (let i in res.data.data) {
            let data = res.data.data[i];
            if (data.catclass == 1) {
              this.cateList.push(data);
            } else {
              this.specList.push(data);
            }
          }
          let list = this.toTree(res.data.data);
          this.treeData = this.treeKey(list);
        });
    },
    showSub() {
      this.showSubTitle = !this.showSubTitle;
    },
    tagChange(value) {
      console.log(`Selected: ${value}`);
    },
    popupScroll() {
      console.log('popupScroll');
    },
    checkRec() {
      this.recommend.check = !this.recommend.check;
      if (this.recommend.check) {
        this.article.recommend = '1';
      } else {
        this.article.recommend = '0';
      }
    },
    checkTypes(index) {
      let typeStr = this.article.type;
      let typeArr = [];
      for (let i in typeStr) {
        typeArr.push(parseInt(typeStr.substr(i, 1)));
      }
      let existIndex = typeArr.indexOf(index);
      if (existIndex > -1) {
        typeArr.splice(existIndex, 1);
      } else {
        typeArr.push(index);
      }
      this.article.type = typeArr.sort().join('');
    },
    getEditorDetail(data) {
      // 获得编辑器内容
      this.article.content = data.content;
      if (data.imgArr.length > 0) {
        this.$http.post('/api/AliyunOss/lists', this.imgParam).then(res => {
          if (res.data.state == 200) {
            this.picLists = res.data.data;
          }
        });
      }
    },
    checkCate(id) {
      const cursor = this.checkArr.indexOf(id);
      if (cursor == -1) {
        this.checkArr.push(id);
      } else {
        this.checkArr.splice(cursor, 1);
      }
    },

    toTree(data) {
      data.forEach(item => {
        delete item.children;
      });
      let map = {};
      data.forEach(item => {
        map[item.catid] = item;
      });
      let val = [];
      data.forEach(item => {
        let parent = map[item.parentid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      return val;
    },
    treeKey(data) {
      let val = [];
      function setName(obj, ide) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].title = obj[i].catname;
          obj[i].key = ide + '-' + i;
          obj[i].value = obj[i].catid;
          if (obj[i].children) {
            obj[i].disabled = true;
          }
          if (obj[i].children) {
            setName(obj[i].children, obj[i].key);
          }
        }
        val = obj;
      }
      setName(data, '0');
      return val;
    },
    filterTreeNode(inputValue, treeNode) {
      return (
        treeNode.componentOptions.propsData.title
          .toLowerCase()
          .indexOf(inputValue.toLowerCase()) >= 0
      );
    },
    /**
     * @function 错别字识别
     */
    cmsword() {
      let content = this.article.content,
        uuid = '211b8307-446b-4573-9471-365c5147ec21';
      this.$http
        .post('https://open.api.cn3x.com.cn/find/cmsword', {
          content: content,
          uuid
        })
        .then(res => {
          if (res.data.errno === 0) {
            const h = this.$createElement;
            let data = res.data.data;
            let list = [];
            if (data.length > 0) {
              data.forEach(item => {
                list.push(
                  h('div', {}, [
                    h('span', '错误：'),
                    h(
                      'span',
                      {
                        style: {
                          color: '#ff7875'
                        }
                      },
                      item.expectTerms + '，'
                    ),
                    h('p', item.explain)
                  ])
                );
              });
            }
            this.$info({
              title: '错字提示',
              content: h('div', {}, list),
              onOk() {}
            });
          }
        });
    },
    /**
     * @function 将emoji转为utf16
     */
    utf16toEntities(str) {
      var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
      str = str.replace(patt, function(char) {
        var H, L, code;
        if (char.length === 2) {
          H = char.charCodeAt(0); // 取出高位
          L = char.charCodeAt(1); // 取出低位
          code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
          return '&#' + code + ';';
        } else {
          return char;
        }
      });
      return str;
    }
  }
};
</script>

<style scoped>
.textMargin {
  margin-top: 30px;
}
.upload-div {
  width: 278px;
  background-color: #fafafa;
  border: 1px dashed #dedede;
  border-radius: 3px;
}
.upload-div:hover {
  border-color: #49b2ff;
}
.anticon-inbox {
  font-size: 48px;
  color: #40a9ff;
}
.channelSelect {
  overflow-y: auto;
  position: absolute;
  width: 200px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.ant-upload-text {
  text-align: center;
  font-size: 16px;
}
.main-form {
  position: absolute;
  top: 10px;
  right: 330px;
  bottom: 0;
  left: 20px;
}
.attr-form {
  /*overflow-y: auto;*/
  position: absolute;
  min-height: 680px;
  width: 300px;
  top: 10px;
  right: 10px;
  bottom: 70px;
}

.article-form {
  top: 0;
  left: 0;
  right: 0;
  bottom: 10px;
  background-color: #fff;
  position: absolute;
  overflow-y: scroll;
  min-height: 820px;
}
.select-type {
  height: 40px;
  line-height: 40px;
  text-align: right;
  font-size: 16px;
  margin-bottom: 10px;
}
.select-type button {
  margin-right: 5px;
}
.title-pic {
  text-align: left;
  padding-left: 10px;
  padding-top: 3px;
}
.ant-upload-drag-icon {
  margin: 40px 0 10px 0;
  text-align: center;
}

.ant-row {
  line-height: 40px;
  margin-bottom: 10px;
}
.ant-row > .ant-row {
  margin-bottom: 0;
}

.checked {
  font-size: 10px;
  padding-top: 7px;
}
.active {
  color: #fff;
  background-color: rgba(82, 196, 26, 0.8);
}
.img-lists {
  height: 90px;
  /*line-height: 90px;*/
}
.img-lists > div {
  border: dashed 1px #d9d9d9;
  border-radius: 3px;
  background-color: #fafafa;
  padding: 2px;
  width: 130px;
  height: 90px;
  position: absolute;
}
.img-lists > div:nth-child(2) {
  right: 0;
}
/*.img-lists>div:nth-child(3){*/
/*    left:190px;*/
/*}*/
/* .picture-area {
  height: 400px;
} */
.picture-list {
  height: 600px;
  /*min-height: 600px;*/
  overflow-y: auto;
}

.picture-list .lists {
  margin: 0 10px;
}
.picture-list .lists ul li {
  float: left;
  width: 205px;
  height: 175px;
  text-align: center;
  cursor: pointer;
  padding: 0 10px;
  margin-bottom: 10px;
}
.picture-list .lists ul li.pic-lists:hover {
  background-color: #f2f6fc;
}
.picture-list .lists .imgs {
  height: 145px;
  line-height: 145px;
}
.picture-list .lists .title {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /*height:28px;*/
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.picture-list .lists ul li:hover .title {
  color: #409eff;
}
.picture-list .lists ul li img {
  vertical-align: middle;
  max-width: 145px;
  max-height: 145px;
  border-radius: 5px;
}
.video-lists-main {
  position: absolute;
  top: 55px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.video-lists {
  padding: 20px 20px 0 20px;
}
.video-lists:hover {
  cursor: pointer;
  background-color: #f2f6fc;
}
.img-del {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 20px;
  line-height: 20px;
  float: right;
}
.spin {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*background-color: #3e3e43;*/
}
.spin >>> div > .ant-spin {
  max-height: none;
}
.cate-set {
  line-height: normal;
}
.cate-set .intro {
  display: block;
  padding-bottom: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #409eff;
}
.img-delete {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 5px;
}
.more {
  width: 90%;
  margin: 10px auto;
}
.more > button {
  width: 100%;
}
</style>
